/**
 * ContactPerson
 */
interface ContactPerson {
    id?: string;
    worktype: ContactWorkType; // 업무 타입
    workname: string;
    name: string;
    email: string;
    createdAt: Date;
    updatedAt: Date;
}

export enum ContactWorkType {
    Inquiry = 'inquiry',
    Report = 'report',
}

export default ContactPerson;